<template>
  <div class="wrapper">
    <div class="popup-wrap">
      <div class="popup-container row">
        <div class="position-relative form-group col-12">
          <span>ID:&nbsp;</span>
          <span class="select-all">{{ data.id }}</span>
        </div>
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Shop Name*</label>
          <input class="form-control mt-2" type="text" :value="data.name" @change.stop.prevent="store.commit('name', $event.target.value)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Event from '@/helper/event.js'

export default {
  mixins: [Event],
  computed: {
    action() {
      return this.config?.action
    },
    storeId() {
      return this.config?.storeId
    },
    accountId() {
      return this.config?.accountId
    },
    submitUri() {
      return `sale-account/update/${this.accountId}`
    },
    data() {
      return this.store.getter('', {})
    }
  },
  mounted() {
    this.$emitter.on('Modal.SaleAccount.Edit.Submit', this.submit)
  },
  unmounted() {
    this.$emitter.off('Modal.SaleAccount.Edit.Submit', this.submit)
  },
  methods: {
    submit(data) {
      this.submitForm(data, {
        done: () => {
          this.$emitter.emit('TableList.Refresh')
          this.$emit('close')
        }
      })
    }
  },
  props: {
    config: Object
  }
}
</script>
